{
  "name": "smart_city",
  "version": "3.160.1-Beta.0",
  "private": true,
  "browser": {
    "fs": false,
    "path": false,
    "os": false,
    "tls": false,
    "net": false,
    "http": false,
    "https": false,
    "stream": false,
    "crypto": false,
    "zlib": false
  },
  "scripts": {
    "ng": "ng",
    "start": "cross-env NODE_ENV=local node ./node_modules/@angular/cli/bin/ng serve --configuration=development",
    "start-development": "cross-env NODE_ENV=development node --max_old_space_size=8192 ./node_modules/@angular/cli/bin/ng serve",
    "start:big": "cross-env NODE_ENV=local  node --max-old-space-size=8192 ./node_modules/@angular/cli/bin/ng serve --configuration=development",
    "build-preview": "cross-env NODE_ENV=preview node --max_old_space_size=8192 ./node_modules/@angular/cli/bin/ng build --configuration=beta",
    "build-production": "cross-env NODE_ENV=production node --max_old_space_size=8192 ./node_modules/@angular/cli/bin/ng build --configuration=production",
    "build-development": "cross-env NODE_ENV=development node --max_old_space_size=8192 ./node_modules/@angular/cli/bin/ng build --configuration=development",
    "lint": "ng lint",
    "format": "oxfmt --write --ignore-path .oxfmtignore \"**/*.{ts,html,scss,css,json,yml,yaml,md}\"",
    "format:check": "oxfmt --check --ignore-path .oxfmtignore \"**/*.{ts,html,scss,css,json,yml,yaml,md}\"",
    "lint-build": "ng lint && node --max_old_space_size=8192 ./node_modules/@angular/cli/bin/ng build --configuration=pull-request",
    "test": "vitest run",
    "test:watch": "vitest",
    "test:coverage": "vitest run --coverage",
    "release-development": "release-it --only-version --preRelease=Development --git.requireBranch=Development",
    "release-beta": "release-it --only-version --preRelease=Beta --git.requireBranch=Beta",
    "release-production": "release-it --only-version --git.requireBranch=main",
    "analyze": "ng build --configuration production --source-map && npx source-map-explorer dist/alumbrado/browser/main*.js --no-border-checks",
    "postinstall": "node fix-lockfile.js"
  },
  "dependencies": {
    "@angular/animations": "21.2.25",
    "@angular/cdk": "^21.2.14",
    "@angular/common": "21.2.25",
    "@angular/compiler": "21.2.25",
    "@angular/core": "21.2.25",
    "@angular/forms": "21.2.25",
    "@angular/material": "^21.2.14",
    "@angular/material-moment-adapter": "^21.2.14",
    "@angular/platform-browser": "21.2.25",
    "@angular/platform-browser-dynamic": "21.2.25",
    "@angular/router": "21.2.25",
    "@angular/service-worker": "21.2.25",
    "@auth0/angular-jwt": "3.0.1",
    "@azure/msal-angular": "4.0.19",
    "@azure/msal-browser": "4.23.0",
    "@ckeditor/ckeditor5-angular": "^11.0.1",
    "@dotenv-run/core": "^1.3.8",
    "@meddv/ngx-pinch-zoom": "^20.0.0",
    "@ngx-translate/core": "14.0.0",
    "@ngx-translate/http-loader": "7.0.0",
    "@sweetalert2/ngx-sweetalert2": "11.0.0",
    "@turf/turf": "5.1.6",
    "angular-fusioncharts": "^4.2.0",
    "azure-maps-control": "2.3.7",
    "azure-maps-drawing-tools": "1.0.5",
    "azure-maps-rest": "2.1.1",
    "babylonjs": "^8.56.1",
    "bn-ng-idle": "2.0.5",
    "canvg": "^3.0.11",
    "ckeditor5": "47.6.2",
    "core-js": "2.6.12",
    "crypto-js": "4.2.0",
    "echarts": "^6.0.0",
    "file-saver": "2.0.5",
    "fusioncharts": "3.23.0",
    "hammerjs": "2.0.8",
    "html2canvas": "1.4.1",
    "javascript-color-gradient": "2.5.0",
    "jose": "^6.2.2",
    "jsmpeg-player": "3.0.3",
    "jspdf": "^4.2.0",
    "jspdf-autotable": "^5.0.7",
    "jszip": "3.10.1",
    "leaflet": "1.9.4",
    "leaflet-control-custom": "1.0.0",
    "leaflet-draw": "1.0.4",
    "lodash": "4.18.1",
    "marked": "^18.0.12",
    "moment": "2.31.0",
    "moment-timezone": "0.5.48",
    "ngx-airis-ui": "^0.21.0",
    "ngx-markdown": "21.3.0",
    "ngx-mat-select-search": "9.0.0",
    "pdfmake": "0.1.72",
    "pdfmake-wrapper": "2.1.3",
    "rxjs": "7.8.2",
    "socket.io-client": "4.8.3",
    "sweetalert2": "11.23.0",
    "tslib": "^2.8.1",
    "uuid": "^11.1.1",
    "windows-iana": "5.1.0",
    "xlsx": "https://cdn.sheetjs.com/xlsx-0.20.3/xlsx-0.20.3.tgz",
    "zone.js": "0.15.1"
  },
  "devDependencies": {
    "@analogjs/vite-plugin-angular": "^2.7.2",
    "@analogjs/vitest-angular": "^2.7.2",
    "@angular-devkit/core": "^21.2.23",
    "@angular-devkit/schematics": "^21.2.23",
    "@angular-eslint/builder": "^20.7.0",
    "@angular-eslint/eslint-plugin": "^20.7.0",
    "@angular-eslint/eslint-plugin-template": "^20.7.0",
    "@angular-eslint/schematics": "^20.7.0",
    "@angular-eslint/template-parser": "^20.7.0",
    "@angular-eslint/utils": "^20.7.0",
    "@angular/build": "^21.2.27",
    "@angular/cli": "^21.2.23",
    "@angular/compiler-cli": "21.2.25",
    "@angular/language-service": "21.2.25",
    "@angular/pwa": "21.2.25",
    "@commitlint/cli": "20.5.0",
    "@commitlint/config-conventional": "20.5.0",
    "@ngx-env/builder": "^21.0.1",
    "@release-it/conventional-changelog": "11.0.1",
    "@types/file-saver": "2.0.7",
    "@types/lodash": "4.17.20",
    "@types/node": "^22.15.0",
    "@types/video.js": "7.3.58",
    "@typescript-eslint/eslint-plugin": "^8.72.0",
    "@typescript-eslint/parser": "^8.72.0",
    "@typescript-eslint/utils": "^8.72.0",
    "@vitest/coverage-v8": "^4.1.11",
    "angular-eslint": "^20.7.0",
    "cross-env": "7.0.3",
    "eslint": "^9.39.5",
    "eslint-plugin-perfectionist": "^5.11.1",
    "jsdom": "^26.1.0",
    "lint-staged": "^17.6.0",
    "oxfmt": "^0.68.0",
    "release-it": "20.2.1",
    "ts-node": "7.0.1",
    "typescript": "5.9.3",
    "typescript-eslint": "^8.72.0",
    "video.js": "8.23.4",
    "vitest": "^4.1.11",
    "webpack-bundle-analyzer": "4.10.2"
  },
  "overrides": {
    "@conventional-changelog/git-client": "2.5.0",
    "axios": "^1.12.1",
    "basic-ftp": "^6.2.3",
    "lodash": "4.18.1",
    "lodash-es": "4.18.1",
    "tough-cookie": "4.1.3",
    "undici": "6.28.1",
    "uuid": "$uuid",
    "xml2js": "0.5.0"
  }
}
